var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.41 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.48,
    y: 12.03,
    width: 2.3,
    height: 13.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 12.03,
    width: 2.3,
    height: 13.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.26,
    y: 12.03,
    width: 2.3,
    height: 13.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.69,4.85H32.07V2.29A2.24,2.24,0,0,0,29.89,0h-5.8A2.24,2.24,0,0,0,21.9,2.29V4.85H13.28v2.3H16v21A3.84,3.84,0,0,0,19.85,32H34.12A3.84,3.84,0,0,0,38,28.16v-21h2.73ZM24.21,2.3h5.56V4.85H24.21ZM35.66,28.16a1.54,1.54,0,0,1-1.54,1.54H19.85a1.54,1.54,0,0,1-1.53-1.54v-21H35.66Z",
    transform: "translate(-13.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.15b1764f.svg";
export { ForwardRef as ReactComponent };